import * as yup from 'yup';
import * as v from 'src/utils/form/validate';

export default function getValidationSchema() {
  const validationSchema = yup.object({
    title: v.validateName(yup, 'назву', 128),
    discount: v.validateName(yup, 'знижку', 64),
    requirements: v.validateName(yup, 'необхідні документи', 80),
    phone: v.validatePhone(yup, false),
    address: v.validateName(yup, 'адресу', 2000, false),
    url: v.validateUrl(yup, false),
    description: v.validateName(yup, 'коментар', 2000, false)
  });

  return validationSchema;
}
